<template>
  <button @click="$emit('click', $event)">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </button>
</template>
<script>
export default {};
</script>


<style scoped>
button {
  border: none;
  background-color: transparent;
}
.dot {
  height: 5px;
  width: 5px;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
}
</style>
